import React from 'react'
import Navbar from '../components/NavBar'
function RitualArts() {
  return (
    <div>
        <Navbar />
      <h1>
        This is a multi-page React App
      </h1>
    </div>
  )
}

export default RitualArts